<template>
    <section class="main">
        <div v-show="isLoading">
            <v-page-loading />
        </div>
        <div v-show="!isLoading">
            <v-page-header :title="getPageTile" />

            <div v-show="hasLoadingError">
                <div class="grid-container">
                    <p class="text-center">
                        {{ loadingError }}
                    </p>
                </div>
            </div>

            <div v-show="!hasLoadingError">
                <div class="grid-container">
                    <div class="grid-x">
                        <div class="cell medium-9 medium-offset-1 large-11 large-offset-0">
                            <div class="wrapper">
                                <v-action-buttons :items="getActionButtons" />

                                <div class="box">
                                    <v-navigation />

                                    <form action="" method="POST" class="filter filter--search" novalidation @submit="onChangeAdminsTableFilter">
                                        <div class="form-group form-group--search">
                                            <input type="text" name="search" class="form-control form-control--small form-control--search" :placeholder="$t('search.term')" v-model="adminsTableFilter.search" />
                                            <button role="button" type="submit" class="button" :title="$t('search')">
                                                {{ $t('search') }}
                                            </button>
                                        </div>
                                    </form>

                                    <v-table :isLoading="adminsTableLoading" :columns="adminsTableColumns" :items="adminsTableItems" :showShowAll="false" :showShowDeactivatedOnly="true" :showDeactivatedOnly="adminsTableFilter.show_deactivated_only" @onChangeShowDeactivatedOnly="onChangeShowDeactivatedOnlyAdminsTableFilter">
                                        <template slot="name" slot-scope="{ row }">
                                            <span class="table-label">{{ row.profile.lastname }}</span>
                                            <span class="table-description">{{ row.profile.firstname }}</span>
                                        </template>
                                        <template slot="phone" slot-scope="{ row }">
                                            <span class="table-label">
                                                <template v-if="row.profile.communication.mobile">{{ row.profile.communication.mobile }}</template>
                                                <template v-else>-</template>
                                            </span>
                                            <span class="table-description">{{ $t('customers.pm.mobile')}}</span>
                                        </template>
                                        <!-- <template slot="userTrackingAcceptedon" slot-scope="{ row }">
                                            <span :class="{ 'u-color--alert': row.userTrackingAcceptedon == null }">
                                                {{
                                                    row.userTrackingAcceptedon == null
                                                        ? $t('account.message.none_yet')
                                                        : $t('date.on') + ' ' + $moment(row.userTrackingAcceptedon.date).format('DD.MM.YYYY')
                                                }}
                                            </span>
                                            <span
                                                class="table-description"
                                                :class="{ 'u-color--alert': row.userTrackingAcceptedon == null }"
                                            >
                                                {{ $t('account.accepted.dsvgo_consent') }}
                                            </span>
                                        </template> -->
                                        <template slot="location" slot-scope="{ row }">
                                            <template v-if="row.location">
                                                <span class="table-label">{{ row.location.company_name }}</span>
                                                <span class="table-description">{{ row.location.city }}</span>
                                            </template>
                                        </template>
                                        <template slot="update" slot-scope="{ row }">
                                            <template v-if="$store.getters.userHasPermission('admin_update')">
                                                <router-link :to="{ name : 'customers-update-customer-admin', params : { custumor : $route.params.customer, account : row.id } }" class="button button--action button--action--edit button--small" :title="$t('update')">
                                                    {{ $t('update') }}
                                                </router-link>
                                            </template>
                                        </template>
                                    </v-table>
                                    <v-pagination :currentPage="adminsTableCurrentPage" :itemsPerPage="adminsTableItemsPerPage" :items="adminsTableItemsCount" @pageClicked="onChangeAdminsTablePage" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import PageHeader from '../../partials/PageHeader';
    import PageLoading from '../../partials/PageLoading';
    import ActionButtons from './../../partials/Foundation/ActionButtons';
    import Navigation from './../Navigation';

    import Table from './../../partials/Foundation/Table';
    import Pagination from './../../partials/Foundation/Pagination';

    export default {
        data() {
            return {
                loading                 : false,
                loadingError            : null,
                customerObject          : {
                    id                      : 0
                },
                adminsTableLoading      : true,
                adminsTableColumns      : [{
                    key                     : 'name'
                }, {
                    key                     : 'phone',
                    width                   : '300px'
                }, /*{
                    key                     : 'userTrackingAcceptedon',
                },*/ {
                    key                     : 'location',
                    width                   : '300px'
                }, {
                    key                     : 'update',
                    width                   : '46px'
                }],
                adminsTableCurrentPage  : this.$route.query.page || 1,
                adminsTableItemsPerPage : 6,
                adminsTableItems        : [],
                adminsTableItemsCount   : 0,
                adminsTableFilter       : {
                    search : this.$route.query.search || '',
                    show_deactivated_only : this.$route.query.show_deactivated_only ||  0
                }
            };
        },
        components : {
            vPageHeader             : PageHeader,
            vPageLoading            : PageLoading,
            vActionButtons          : ActionButtons,
            vNavigation             : Navigation,
            vTable                  : Table,
            vPagination             : Pagination
        },
        computed : {
            isLoading : function () {
                return this.loading;
            },
            hasLoadingError : function () {
                return this.loadingError !== null;
            },
            getPageTile : function () {
                if (this.customerObject.company_name) {
                    return this.customerObject.company_name;
                }

                return this.$t('admins.title');
            },
            getActionButtons : function () {
                let buttons = [];

                if (this.$store.getters.userHasPermission('admin_create')) {
                    buttons.push({
                        action  : 'create-new',
                        router  : { name : 'customers-create-customer-admin', params : { custumor : this.$route.params.customer } }
                    });
                }

                if (this.$store.getters.userHasPermission('project_create')) {
                    buttons.push({
                        action  : 'create-new',
                        title   : this.$t('project.create_quick.title'),
                        router  : { name : 'customers-create-customer-project', params : { custumor : this.$route.params.customer } }
                    });
                }

                return buttons;
            }
        },
        created : function () {
            this.onUpdateCustomer();
        },
        methods : {
            onUpdateCustomer : function() {
                this.loadingError = null;

                if (!this.$route.params.customer) {
                    this.onUpdateAdminsTableItems();
                } else {
                    let promise = this.$api.clearParams()
                        .get('customers/' + this.$route.params.customer + '/get');

                    promise.then((response => {
                        this.customerObject = response.data.data;

                        this.onUpdateAdminsTableItems(true);
                    }).bind(this)).catch((error => {
                        this.loadingError = error.response.data.message;
                    }).bind(this)).finally((() => {
                        this.loading = false;
                    }).bind(this));

                    this.loading = true;
                }
            },
            onUpdateFilterParameters: function () {
                let query = {
                    'page' : this.adminsTableCurrentPage
                };

                for (let key in this.adminsTableFilter) {
                    if (this.adminsTableFilter[key]) {
                        query[key] = this.adminsTableFilter[key];
                    }
                }

                this.$router.push({query : query});
            },
            onChangeAdminsTablePage : function (page) {
                this.adminsTableCurrentPage = page;

                this.onUpdateAdminsTableItems();
            },
            onChangeAdminsTableFilter : function (event) {
                event.preventDefault();

                this.adminsTableCurrentPage = 1;

                this.onUpdateAdminsTableItems();
            },
            onChangeShowDeactivatedOnlyAdminsTableFilter : function (show) {
                this.adminsTableFilter.show_deactivated_only = show;

                this.onUpdateAdminsTableItems();
            },
            onUpdateAdminsTableItems : function (firstUpdate) {
                if (!firstUpdate) {
                    this.onUpdateFilterParameters();
                }

                let promise = this.$api.clearParams()
                    .addParam('customer', this.$route.params.customer)
                    .addParam('usertype', this.$helpers.usertypes.clientadmin + ',' + this.$helpers.usertypes.client)
                    .addParam('show_deactivated_only', this.adminsTableFilter.show_deactivated_only)
                    .addParam('search', this.adminsTableFilter.search)
                    .setPageParams(this.adminsTableCurrentPage, this.adminsTableItemsPerPage)
                    .setSortParams('createdon', 'desc')
                    .get('accounts');

                promise.then((response => {
                    this.adminsTableItems       = response.data.data;
                    this.adminsTableItemsCount  = response.data.meta.pagination.total;

                    this.adminsTableLoading     = false;
                }).bind(this)).catch((error => {
                    this.adminsTableItems       = [];
                    this.adminsTableItemsCount  = 0;

                    this.adminsTableLoading     = false;
                }).bind(this));

                this.adminsTableLoading = true;
            }
        }
    }
</script>
